var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmptyDmSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#F5F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0111 49.3756C54.7794 49.3756 58.9238 44.9262 58.9238 39.1327C58.9238 33.4088 54.7794 29.168 50.0111 29.168C45.2429 29.168 41.0985 33.5015 41.0985 39.1791C41.0985 44.9262 45.2206 49.3756 50.0111 49.3756ZM35.996 70.8346H63.9817C67.5022 70.8346 68.75 69.7918 68.75 67.7525C68.75 61.7736 61.553 53.5237 49.9889 53.5237C38.447 53.5237 31.25 61.7736 31.25 67.7525C31.25 69.7918 32.4978 70.8346 35.996 70.8346Z",
    fill: "#3456FF",
    fillOpacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyDmSearch);
export default __webpack_public_path__ + "static/media/icon-empty-dm-search.fcf3f793e0d8e9f640fdc907143b39e1.svg";
export { ForwardRef as ReactComponent };